import { call, put, takeEvery } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { RetentionSettingsValues } from 'pages/MediaCluster/types';
import { MediaNode } from '../types';
import {
  requestNodes,
  getNodesSuccess,
  getNodesError,
  setModulClasterSuccess,
  setModulClasterError,
  requestSetModulClaster,
  getMediaClusterSettingsSuccess,
  getMediaClusterSettingsError,
  requestMediaClusterSettings,
} from './slice';
import { SetMediaCluster, getMediaClusterSettings, getMediaClusterStatus } from '../../../api/system';

export function* mediaNodesRequestSaga() {
  try {
    const response: AxiosResponse<MediaNode[]> = yield call(getMediaClusterStatus, {});
    if (response) {
      yield put(getNodesSuccess({ nodes: response.data }));
    }
  } catch (error) {
    yield put(getNodesError(error.message));
  }
}

export function* setMediaClusterRequestSagaWatch(actions: PayloadAction<RetentionSettingsValues>) {
  try {
    yield call(SetMediaCluster, actions.payload);
    yield put(setModulClasterSuccess());
  } catch (e) {
    setModulClasterError(e.message);
  }
}

export function* mediaClusterSettingsSagaWatch() {
  try {
    const response: AxiosResponse<RetentionSettingsValues> = yield call(getMediaClusterSettings as any);
    if (response) {
      yield put(getMediaClusterSettingsSuccess(response.data));
    }
  } catch (e) {
    if (e instanceof Error) {
      yield put(getMediaClusterSettingsError(e));
    }
  }
}

export function* mediaNodesRequestWatchSaga() {
  yield takeEvery(requestNodes, mediaNodesRequestSaga);
}

export function* setMediaClusterRequestSaga() {
  yield takeEvery(requestSetModulClaster, setMediaClusterRequestSagaWatch);
}

export function* mediaClusterSettingsSaga() {
  yield takeEvery(requestMediaClusterSettings, mediaClusterSettingsSagaWatch);
}
